/* eslint-disable @typescript-eslint/no-explicit-any */
import { mergeAttributes } from '@tiptap/core';
import { BulletList as TiptapBulletList } from '@tiptap/extension-bullet-list';
import { optimizeStyle, simpleElementNodeView } from './utilityFunctions';
import { CommonListOptions } from '../editorUtilityFunctions/lintEditorType';
import { commonListAttributes, createToggleListCommand } from './listExtensionsCommon';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    bulletLists: {
      toggleBulletListContent: (numberingType: string) => ReturnType;
    };
  }
}

export const BulletList = TiptapBulletList.extend<CommonListOptions>({
  name: 'bulletList',

  addOptions() {
    return {
      ...this.parent?.(),
      itemTypeName: 'listItem',
      HTMLAttributes: {},
      keepMarks: true,
      keepAttributes: true,
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      listStyleType: {
        default: 'disc',
        parseHTML: (el) => el.style.listStyleType || 'disc',
        renderHTML: (attr) => ({
          style: `list-style-type: ${attr.listStyleType};`,
        }),
      },
      ...commonListAttributes,
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['ul', optimizeStyle(mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)), 0];
  },

  addCommands() {
    return {
      ...this.parent?.(),
      toggleBulletListContent: createToggleListCommand('bulletList'),
    };
  },

  addNodeView() {
    return simpleElementNodeView('ul');
  },
});
